import { NonCachedSearchType, ProductModel } from 'interfaces'
import { Vehicle as VehicleInterface } from '../../../store/models/Vehicles'

export enum GaTrackOption {
  track,
  doNotTrack,
}

export const buildProductName = (product: ProductModel): string => {
  return `${product.description} ${
    product.brandName ?? product.manufacturerName
  } ${product.partNumber}`
}

export const buildVehicleStringDimension = (
  v: VehicleInterface,
  regionId: string
): string => {
  // TODO: check if we can use `isMiscellaneousVehicle` here.
  if (v?.make?.value === 'MISCELLANEOUS' || !v?.year?.value) {
    return '0-0-0-0-0-0' // To match B2C format when a vehicle is not selected
  }
  return `AC-${v.year?.id}-${v.make?.id}-${v.model?.id}-${regionId}-${v.engine?.id}`
}

export const gaSearchTypeMap = new Map<number, string>([
  [NonCachedSearchType.searchByText, 'Product Search (AST Search)'],
  [NonCachedSearchType.searchBySaytCategories, 'SAYT'],
  [NonCachedSearchType.searchByInterchange, 'Interchange'],
  [NonCachedSearchType.searchByNavigation, 'Fitment Catalog'],
  [NonCachedSearchType.searchGfxByNavigation, 'GFX'],
  [
    NonCachedSearchType.searchByAstNavigation,
    'Product Catalog (AST Navigation)',
  ],
  [NonCachedSearchType.searchBySpecificParts, 'Part Lists'],
])

export const getSelectedProductQtyAvailable = (data: ProductModel): number => {
  const selectedLocation = data.location.find((loc) => loc.isSelected)
  return selectedLocation
    ? selectedLocation.qtyAvailable
    : data.location[0]?.qtyAvailable
}
